import { combineReducers } from 'redux';

import { REQUEST_ENROLLMENT, SUCCESS_ENROLLMENT, FAILURE_ENROLLMENT } from './constants';

const successEnrollmentSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_ENROLLMENT:
            return true;
        case REQUEST_ENROLLMENT:
        case FAILURE_ENROLLMENT:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ENROLLMENT:
            return true;
        case FAILURE_ENROLLMENT:
        case SUCCESS_ENROLLMENT:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ENROLLMENT:
            return action.response.message;
        case REQUEST_ENROLLMENT:
        case SUCCESS_ENROLLMENT:
            return '';
        default:
            return state;
    }
};

const status = (state = 0, action) => {
    switch (action.type) {
        case FAILURE_ENROLLMENT:
        case SUCCESS_ENROLLMENT:
            return action.response.status;
        case REQUEST_ENROLLMENT:
            return 0;
        default:
            return state;
    }
};

export default combineReducers({ successEnrollmentSubmit, fetching, error, status });



// WEBPACK FOOTER //
// ./src/services/enrollment/reducer.js